import React from "react";
import Image from "next/image";
import { BLUR_DATA_URLS } from "@/lib/blur-data-urls";

const Background: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black/65">
      {/* Background image */}
      <Image
        src="/assets/images/background.webp"
        alt=""
        fill
        className={`fixed inset-0 w-full h-full object-cover z-0 transition-opacity duration-1000 blur-sm scale-105`}
        aria-hidden="true"
        priority
        placeholder="blur"
        blurDataURL={BLUR_DATA_URLS.background}
        fetchPriority="high"
      />
      {/* Overlay content */}
      <div className="relative z-10 flex min-h-screen w-full items-stretch h-full">
        {children}
      </div>
    </div>
  );
};

export default Background;
